import { Injectable } from "@angular/core";
import { NavController, Platform } from "ionic-angular";

@Injectable()
export class DesktopService {
    private leftPane: NavController;
    private rightPane: NavController;

    public constructor(private platform: Platform) {
    }

    public isDesktop(): boolean {
        return false;
    }

    public setLeftPane(pane: NavController) {
        this.leftPane = pane;
    }

    public getLeftPane(): NavController {
        return this.leftPane;
    }

    public setRightPane(pane: NavController) {
        this.rightPane = pane;
    }

    public getRightPane(): NavController {
        return this.rightPane;
    }
}



// WEBPACK FOOTER //
// ./src/providers/desktop-service.ts